export default "__VITE_ASSET__c44b30e0__"